import { statusTypes } from "./types";

export const statusActionTypes = {
  AddStatusesAsync() {
    return {
      type: statusTypes.ASYNC_GET_STATUSES,
    };
  },
};
